import { render, staticRenderFns } from "./DashboardEvent.vue?vue&type=template&id=5ea1d1b4&scoped=true&"
import script from "./DashboardEvent.vue?vue&type=script&lang=js&"
export * from "./DashboardEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea1d1b4",
  null
  
)

export default component.exports